// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {UserGroupPopoverController} from './user_group_popover_controller';

export default UserGroupPopoverController;
